import { GroupedType } from '../controls/grid/GroupedType';
import { IGroupedItem } from '../controls/grid/IGroupedItem';
import { SearchTermList } from './SearchTermList';

export class SearchTermListGroupedItem extends SearchTermList implements IGroupedItem {
    public _class: string;
    public value: string;
    public type: GroupedType;

    constructor(searchTermList: SearchTermList, type: GroupedType) {
      super(searchTermList.id, searchTermList.projectId, searchTermList.name, []);
      this._class = 'SearchTermListGroupedItem';
      this.value = "";
      this.type = type;
    }
}
